import React, { Fragment } from "react";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import { Box, Container, Divider, Stack, Typography } from "@mui/material";
import Skeletons from "../../../components/loader/Skeletons";
import SimpleAlert from "../../../components/display/SimpleAlert";
import ToggleDrawer from "../../../contexts/ToggleDrawer";
import UserProvider from "../../../contexts/UserProvider";
import MobileAppointement from "./MobileAppointement";
import DesktopAppointement from "./DesktopAppointement";
import useGetAppointments from "../../../hooks/useGetAppointments";
import { useIsMobile } from "../../../utils/Functions";
import useUser from "../../../hooks/useUser";
import { useTranslation } from "react-i18next";
import DesktopViewer from "../../../components/wrappers/DesktopViewer";
//This is a temp component
//When the rest of the home page views are done we can probably delete this component
//Currently 2 different entities are being fetched for the full screen and mobile versions
//A DTO is being passed for user mobile view and a list of appointments for everything else
//Later we can extend the DTO to function for all pages
export default function OtherHomePageViews() {
  const { t } = useTranslation();
  const { profile, isLoading: userLoading } = useUser();
  const userName = profile.firstName;
  const isMobile = useIsMobile();
  return (
    <>
      <PageContentWrapper>
        <Stack spacing={5}>
          {userLoading ? (
            <Skeletons height={25} />
          ) : (
            <Typography
              variant="h3"
              fontWeight={"bold"}
              textAlign={"center"}
              sx={{
                fontSize: {
                  xs: "1.5rem",
                  sm: "2rem",
                  md: "3rem",
                },
                lineHeight: 1.2,
                margin: "0 auto",
                color: "info",
              }}
            >
              {`${t("Hi")} ${userName}! ${t("WelcomeTo")} ${"Zookeeper"}`}
            </Typography>
          )}
          <Divider />
        </Stack>
      </PageContentWrapper>
      <Fragment>
        {isMobile ? (
          <Container sx={{ mb: 10 }}>
            <Stack spacing={5}>
              <ToggleDrawer>
                <MobileAppointement />
              </ToggleDrawer>
            </Stack>
          </Container>
        ) : null}
        <DesktopViewer>
          <Box ml={5} mr={5}>
            <ToggleDrawer>
              <DesktopAppointement />
            </ToggleDrawer>
          </Box>
        </DesktopViewer>
      </Fragment>
    </>
  );
}
